/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CommentRequest model module.
 * @module model/CommentRequest
 * @version V1
 */
class CommentRequest {
    /**
     * Constructs a new <code>CommentRequest</code>.
     * @alias module:model/CommentRequest
     */
    constructor() { 
        
        CommentRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CommentRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CommentRequest} obj Optional instance to populate.
     * @return {module:model/CommentRequest} The populated <code>CommentRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommentRequest();

            if (data.hasOwnProperty('jobId')) {
                obj['jobId'] = ApiClient.convertToType(data['jobId'], 'Number');
            }
            if (data.hasOwnProperty('comment')) {
                obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
            }
            if (data.hasOwnProperty('commentFileIds')) {
                obj['commentFileIds'] = ApiClient.convertToType(data['commentFileIds'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CommentRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommentRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['comment'] && !(typeof data['comment'] === 'string' || data['comment'] instanceof String)) {
            throw new Error("Expected the field `comment` to be a primitive type in the JSON string but got " + data['comment']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['commentFileIds'])) {
            throw new Error("Expected the field `commentFileIds` to be an array in the JSON data but got " + data['commentFileIds']);
        }

        return true;
    }


}



/**
 * @member {Number} jobId
 */
CommentRequest.prototype['jobId'] = undefined;

/**
 * @member {String} comment
 */
CommentRequest.prototype['comment'] = undefined;

/**
 * @member {Array.<Number>} commentFileIds
 */
CommentRequest.prototype['commentFileIds'] = undefined;






export default CommentRequest;

